import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router";

import { userManualHandler } from "utils/utils";
import { userProfileStrings } from "constants/constantStrings";
import { SETTINGS_PAGES } from "constants/pages.constant";

import UserIcon from "assets/UserProfile/user_Profile_Big.svg";

import { getSettingsOptions } from "./settings.options";

import "./index.scss";

const SettingsContainer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useSelector(state => state);
  const { UserName, CompanyName, isAdmin, hasSystemsAccess } = user;

  const [filteredSettingOption, setFilteredSettingOption] = useState([]);
  const [activePage, setActivePage] = useState("");

  useEffect(() => {
    const options = getSettingsOptions(isAdmin, hasSystemsAccess);
    setFilteredSettingOption(options);
  }, []);

  useEffect(() => {
    const { pathname } = location;
    const paths = pathname.split("/");
    const page = paths[paths.length - 1];
    setActivePage(page);
  }, [location]);

  const settingChangeHanlder = page => {
    if (page === SETTINGS_PAGES.USERGUIDE) {
      userManualHandler();
    } else {
      navigate(page); // Change setting page
      setActivePage(page);
    }
  };
  const getUserRole = () => (user.isAdmin ? userProfileStrings.administrator : user.isTier1 ? userProfileStrings.tier1 : user.isTier2 ? userProfileStrings.tier2 : userProfileStrings.tier1);
  const getActiveOptionClass = page => (page === activePage ? "activeStatus" : "");

  return (
    <div className="d-flex height100">
      <div className="user-container">
        <div className="user-detail">
          <span>
            <img src={UserIcon} alt="userIcon" />
          </span>
          <span className="user-Name">{UserName}</span>
          {CompanyName && (
            <span className="user-org">
              {userProfileStrings.organization}: {CompanyName}
            </span>
          )}
          <span className="user-role">
            {userProfileStrings.access} {getUserRole()}
          </span>
        </div>
        <ul>
          {filteredSettingOption.map(
            (option, index) =>
              option.isVisible && (
                <li
                  id={option.id}
                  key={option.id + index}
                  className={getActiveOptionClass(option.id)}
                  onClick={() => settingChangeHanlder(option.id)}
                >
                  <div>
                    <img src={option.icon} alt={option.id} />
                    {option.name}
                  </div>
                  {option.secondaryIcon && <img src={option.secondaryIcon} alt="launch" />}
                </li>
              )
          )}
        </ul>
      </div>
      <div className="fullWidth scrollVertical ">
        <Outlet />
      </div>
    </div>
  );
};

export default SettingsContainer;
